import React from 'react';
import Header from '../components/Header';
import PagesHero from '../components/PagesHero';
import PlanSection from '../components/PlanSection';
import TestimonialSection from '../components/TestimonialSection';
import FooterSection from "../components/FooterSection";
import NumberCount from "../components/NumberCount";

export default function Plans() {
  return (
    <div>
      <Header />
      <PagesHero page={"plans"}/>
      <PlanSection />
      <TestimonialSection />
      <NumberCount />
      <FooterSection />
    </div>
  )
}
